﻿import React from 'react';
import {connect} from 'react-redux';

/* abstract */
class DynamicFormToggleableRow extends React.Component {
    constructor(props) {
        super(props);

        // find option value that toggles sub question group (usually 'Ja' or 'Nej')
        const toggleGroupOnValue = props.questionGroup.questionType === 'Radio'
            ? props.questionGroup.options
                .filter(option => option.togglesSubQuestionGroup)
                .reduce((_, option) => option.text, null)
            : null;

        const groupIsVisible = props.questionGroup.questionType === 'Radio'
            && (props.questionGroup.id in props.formInputs
                && props.formInputs[props.questionGroup.id].value === toggleGroupOnValue)
            || props.questionGroup.value === toggleGroupOnValue;

        const groupInited = props.questionGroup.subQuestionGroup
            && props.questionGroup.subQuestionGroup.id in props.formInputs;

        this.toggleGroupOnValue = toggleGroupOnValue;
        this.state = {subQuestionVisibility: groupIsVisible ? true : false};

        if (groupIsVisible && !groupInited && props.currentStep === 0 && props.questionGroup.subQuestionGroup) {
            props.addQuestionGroupInputs([props.questionGroup.subQuestionGroup], 0, 1);
        }
    }

    toggleSubQuestions = (e) => {
        const subQuestionGroup = this.props.questionGroup.subQuestionGroup;
        if (subQuestionGroup && subQuestionGroup.questions.length) {
            if (!this.state.subQuestionVisibility && e.target.value === this.toggleGroupOnValue) {
                this.props.addQuestionGroupInputs([subQuestionGroup], 0, 1);
                this.setState({subQuestionVisibility: true});
            } else if(this.state.subQuestionVisibility && e.target.value !== this.toggleGroupOnValue) {
                this.props.removeQuestionGroupInputs([subQuestionGroup], 0, 3);
                this.setState({subQuestionVisibility: false});
            }
        }
    }
}

const connectToggleable = (classObject) => {
    const mapStateToProps = (state) => {
        return {
            currentStep: state.pageCurrentStep,
        };
    };

    const mapDispatchToProps = (dispatch) => {
        return {};
    };

    return connect(mapStateToProps, mapDispatchToProps)(classObject);
};

export {
    DynamicFormToggleableRow,
    connectToggleable
};
